<template lang="html">
  <div>
    <div :class='{"sideBar": true, "fade-in": showToggleButton}' @mouseenter='openSideBar'>
      <i class="fa fa-bars primary-green-text left"></i>
    </div>
    <side-bar
      :show='sideBarToggle'
      :type='sideBarType'
      :offerNames='filteredOffers'
      :sidebarHeader='sideBarTitle'
      :handleEvent='childEvent'
      @sidebarInactive='closeSideBar'
      :screenName="screenName">
    </side-bar>
    <div
      v-if="headers"
      :style="{'z-index': '1', 'position': 'fixed', 'background': 'white', 'margin-left': '20px'}"
      :class="{'height-10': offerTypeFlag, 'height-12': !offerTypeFlag}">
      <div class="">
        <div v-if="pastOrPendingFlag === 'PAST'" class="">
          <div :style="{'padding-top': '1rem', 'margin-left': '1.5rem', 'font-size': '1.5rem', 'vertical-align': 'sub'}">Estimated figures are marked with
            <span class='primary-green-text' :style="{'font-weight': 'bold'}">GREEN</span>
            and Actual figures are marked with
            <span class='black-text' :style="{'font-weight': 'bold'}">BLACK</span>
          </div>
        </div>
        <div class="inline-block">
          <div class="tooltip">
            <span :style="{'padding-left': '1.5rem', 'font-size': '1.3rem'}">Offer Name: </span>
            <span class="" :style="{'padding-left': '0.5rem', 'font-size': '1.2rem', 'color': '#026937'}">{{offerName}}</span>
            <span class="tooltiptext">{{gettersSelectedOffer.name}}</span>
          </div>
          <div class="">
            <span :style="{'padding-left': '1.5rem', 'font-size': '1.3rem'}">Campaign Period: </span>
            <span :style="{'padding-left': '0.5rem', 'font-size': '1.2rem', 'color': '#026937'}">{{gettersAggInputData.period.name}}</span>
          </div>
          <div class="">
            <span :style="{'padding-left': '1.5rem', 'font-size': '1.3rem'}">Store: </span>
            <span :style="{'padding-left': '0.5rem', 'font-size': '1.2rem', 'color': '#026937'}">{{gettersAggInputData.storeLevel.name}}</span>
          </div>
        </div>
        <div :style="{'float': 'right', 'margin-top': '1rem'}" class='inline-block position-relative row' v-if="detailedData && pastOrPendingFlag === 'PENDING'">
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': true}"
            @click="openChartsVue">
            <span v-if="!buttonEnabled">Analytics</span>
            <span v-else="buttonEnabled">Chart And Simulation</span>
          </button>
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': buttonEnabled}"
            v-if='buttonEnabled'
            @click="rejectOffer"
            >
            Reject offer
          </button>
          <button
            type="button"
            :class="{'width_3': true, 'primary-green-bg': buttonEnabled}"
            v-if='buttonEnabled'
            @click="approveWithChanges">
            Approve with changes
          </button>
          <button
            v-if='buttonEnabled'
            type="button"
            :class="{'width_3': true, 'primary-green-bg': buttonEnabled}"
            @click="showGoalsAndDisplay">
            Approve Offer
          </button>
        </div>
        <template v-else class="align-right">
          <button
            type="button"
            :class="{'width_4': true, 'margin-left': true, 'primary-green-bg': buttonEnabled}"
            v-if='buttonEnabled'
            @click="openChartsVue">
            Chart And Simulation
          </button>
        </template>
      </div>

      <div @scroll='topScrollContainer'
        id='scrollWrapper' class="position-relative scrollWrapper"
        :style="{'margin-left': `${marginLeft}px`, width: `${scrollableWidth}px`, 'min-width': `${tableContainerWidth}px`}">
        <div class='simulateScrollDiv' :style='{width:  `${scrollableChildrenWidth * detailedData.length - (Math.floor(Number((detailedData.length.toString()).replace(/.$/,"0")) / 2))}rem`}'>
        </div>
      </div>
    </div>
    <div v-if='headers !== null' id="outer-div-min" class="outer-div-min" >
      <div class="inner-div" id='offersComponentInnerDiv' :class="{'padding-top-8': offerTypeFlag, 'padding-top-10': !offerTypeFlag}">
        <div class="inline-block margin-fix" id='offersHeaderContainer'>
          <vertical-header-table :data='headers' :styles='tableStyles.headerTableStyles'></vertical-header-table>
        </div>
        <div class="inline-block margin-fix" id='offersSummaryContainer'>
          <data-table :data='aggregatedData' :styles='tableStyles.summaryTableStyles' :stringPadding='aggregatedTablePadding'></data-table>
        </div>
        <div @scroll='bottomScrollContainer' id='offersDetailsScrollableX' class="scrollable-x inline-block margin-fix" :style='{width: `${scrollableWidth}px`}'>
          <div v-if='detailedData !== null'
            class="table-container"
            :style='{width:  `${scrollableChildrenWidth * detailedData.length - (Math.floor(Number((detailedData.length.toString()).replace(/.$/,"0")) / 2))}rem`}'
          >
            <div
              class="inline-block margin-fix"
              v-for='(data, i) in detailedData'
              :style='{width: `${scrollableChildrenWidth}rem`}'>
              <data-table
                v-if="pastOrPendingFlag === 'PENDING'"
                :data='data'
                :styles='tableStyles.detailsTableStyles'
                :stringPadding='detailedDataPadding'
                :functions='editPetDepotFunding'>
              </data-table>
              <data-table
                v-else-if="pastOrPendingFlag === 'PAST' && (i > 0 && i % 2 !== 0)"
                :data='data'
                :styles='tableStyles.detailsTableStyles'
                :stringPadding='detailedDataPadding'
                :functions='editPetDepotFunding'
                pendingOrPast='PAST'>
              </data-table>
              <data-table
                v-else-if="pastOrPendingFlag === 'PAST'"
                :data='data'
                :styles='tableStyles.detailsTableStyles'
                :stringPadding='detailedDataPadding'
                :functions='editPetDepotFunding'
                pendingOrPast='PENDING'>
              </data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else="headers !== null" class='preview'>
      <h2 class='grey-text'>{{ defaultNote }}</h2>
    </div>
    <pop-up :closePopUp='closePopUp' v-if='popUp' :type='popUpType' :styles='mainContainerStyle' :data='gettersGoalsAndDisplay.value'></pop-up>
    <!-- <div v-if="pastOrPendingFlag === 'PAST'" class="notification">
      <stickyNotifications>
        Estimated figures are marked with
        <span class='primary-green-text'>Green</span>
        and Actual figures are marked with
        <span class='black-text'>Black</span>.
      </stickyNotifications>
    </div> -->
  </div>
</template>

<script>
import VerticalHeaderTable from 'src/components/shared/flexTables/VerticalHeaderTable'
import DataTable from 'src/components/shared/flexTables/DataTable'
import { tableStyles } from './tableStyles'
import SideBar from 'src/components/shared/SideBar'
import { mainContainerStyle } from 'src/components/pop-up/mainContainerStyle'
import * as NameSpace from '../../store/NameSpace'
import PopUp from 'src/components/pop-up/Main'
import { mapActions, mapGetters } from 'vuex'
import { TableHeightByFixedWidth } from 'src/Services/tableLayoutHelper/height'
import stickyNotifications from 'src/components/shared/stickyNotifications'
import { isSuperUser } from 'src/components/shared/helper/superUser'

export default {
  data () {
    return {
      headers: null,
      tableData: null,
      aggregatedData: null,
      aggregatedTablePadding: {
        length: 30
      },
      detailedDataPadding: {
        length: 40
      },
      detailedData: [],
      tableStyles: tableStyles,
      sideBarToggle: false,
      mainContainerStyle: mainContainerStyle,
      popUp: false,
      showToggleButton: true,
      scrollableWidth: '0px',
      scrollableChildrenWidth: 15,
      sideBarType: 'offerList',
      popUpType: null,
      defaultNote: 'Data will be displayed here once you select your offer name from sidebar.',
      simulationRouteName: 'simulation',
      waterfallRouteName: 'waterfall',
      previousRouterPath: '/pending-offers/selected-offers',
      nextPastRouterPath: '/chart-graph-simulation',
      previousPastRouterPath: '/pending-offers/selected-offers',
      landingScreen: '/pending-offers',
      msg: ['Values must meet the following:-', '1. Should only be numeric.', '2. Can either start by +, - or digits', '3. Can have max two digits before or after decimal point.'],
      editPetDepotFunding: this.submitEditedData,
      sideBarTitle: 'OFFER NAMES',
      marginLeft: 0,
      pastOrPendingFlag: 'PENDING',
      tableContainerWidth: 0,
      screenName: 'ItemLevel',
      offerTypeFlag: true
    }
  },
  computed: {
    ...mapGetters({
      gettersGoalsAndDisplay: NameSpace.GET_GOALS_AND_DISPLAY,
      gettersOfferNames: NameSpace.GET_OFFERS,
      gettersOfferDetails: NameSpace.GET_OFFER_DETAILS_DATA,
      gettersOfferDetailsError: NameSpace.GET_OFFER_DETAILS_ERRORS,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersAggCellData: NameSpace.GET_SELECTED_AGG_DATA
    }),
    offerName () {
      let offerName = this.gettersSelectedOffer.name
      if (offerName && offerName.length > 60) {
        return (offerName.substring(0, 60) + '...')
      }
      return offerName
    },
    filteredOffers () {
      let offers = this.gettersOfferNames.data
      if (offers && offers.length > 0) {
        return offers.map(e => {
          return { name: e[0].value, id: e[0].id }
        })
      }
    },
    offerStatus () {
      return this.gettersAggCellData.status
    },
    buttonEnabled () {
      if (isSuperUser()) {
        return true
      }
      return this.gettersOfferDetails.functionable
    }
  },
  beforeDestroy () {
    this.resetOfferDetails()
    this.resetFunctionable()
  },
  watch: {
    gettersGoalsAndDisplay () {
      if (this.gettersGoalsAndDisplay.value) {
        this.popUpType = 'goalsAndDisplayType'
        this.popUp = true
        this.mainContainerStyle = mainContainerStyle.mainStyle.goalsAndDisplayStyle
      }
    },
    gettersOfferDetails () {
      this.headers = this.gettersOfferDetails.headers
      this.aggregatedData = this.gettersOfferDetails.aggregatedData
      // if (this.aggregatedData && this.aggregatedData[8]) {
      //   this.aggregatedData[8] = this.aggregatedData[8].value
      // }
      let orginalData = this.gettersOfferDetails.detailedData
      // if (this.pastOrPendingFlag === 'PAST') {
      //   let array = []
      //   for (let i = 0; i < orginalData.length; i++) {
      //     array.push(orginalData[i])
      //     array.push(orginalData[i])
      //   }
      //   this.detailedData = array
      // } else {
      //   this.detailedData = orginalData
      // }
      this.detailedData = orginalData
    },
    gettersOfferDetailsError () {
      if (this.gettersOfferDetailsError) {
        this.refreshOffersData()
        this.pop({
          header: 'Validation Failed!',
          message: this.gettersOfferDetailsError,
          type: 'ERROR',
          buttons: {
            accept: {
              text: 'OKAY'
            }
          }
        })
      }
    }
  },
  methods: {
    ...mapActions({
      actionRequestOfferDetails: NameSpace.REQUEST_OFFER_DETAILS_DATA,
      actionGetGoalsAndDisplay: NameSpace.ACTION_GOALS_AND_DISPLAY,
      actionEditPetDepotFunding: NameSpace.ACTION_UPDATE_PET_DEPOT_FUNDING,
      resetFunctionable: NameSpace.RESET_FUNCTIONABLE_TO_DEFAULT,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      resetOfferDetails: NameSpace.RESET_OFFER_DETAILS
    }),
    refreshOffersData () {
      if (this.pastOrPendingFlag === 'PAST') {
        this.offerTypeFlag = false
        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true })
      } else {
        this.offerTypeFlag = true
        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id })
      }
    },
    submitEditedData (record, id) {
      let value = record.value
      if (this.validateInputField(value)) {
        this.refreshOffersData()
        this.pop({
          header: 'Validation Failed!',
          message: this.msg,
          type: 'ERROR'
        })
      } else {
        this.actionEditPetDepotFunding({
          offerId: this.gettersSelectedOffer.id,
          storeLevel: this.gettersAggInputData.storeLevel.id,
          petDepotFunding: value,
          itemId: id
        })
      }
    },
    openSideBar (e) {
      this.sideBarToggle = true
      this.showToggleButton = false
    },
    closeSideBar (e) {
      this.showToggleButton = true
      this.sideBarToggle = false
    },
    getScrollableWidth () {
      if (
        this.headers !== null &&
        document.getElementById('offersComponentInnerDiv') &&
        document.getElementById('offersHeaderContainer') &&
        document.getElementById('offersSummaryContainer')
      ) {
        let offersComponentInnerDiv = document.getElementById('offersComponentInnerDiv').clientWidth
        let offersHeaderContainer = document.getElementById('offersHeaderContainer').clientWidth
        let offersSummaryContainer = document.getElementById('offersSummaryContainer').clientWidth
        let paddingOnInnerDiv = 50
        return offersComponentInnerDiv - offersHeaderContainer - offersSummaryContainer - paddingOnInnerDiv
      }
    },
    getMarginLeft () {
      if (
        this.headers !== null &&
        document.getElementById('offersComponentInnerDiv') &&
        document.getElementById('offersHeaderContainer') &&
        document.getElementById('offersSummaryContainer')
      ) {
        let offersComponentInnerDiv = document.getElementById('offersHeaderContainer').clientWidth
        let aggDataContainer = document.getElementById('offersSummaryContainer')
        let scrollWrapper = document.getElementById('outer-div-min')
        let diff = offersComponentInnerDiv + aggDataContainer.clientWidth
        diff = diff + 15
        this.tableContainerWidth = scrollWrapper.clientWidth - (diff + 40)
        return diff
      }
    },
    getScrollableChildrenWidth (n) {
      // console.log(`${Math.floor(100 / n)}%`)
      return `${(100 / n)}%`
    },
    showGoalsAndDisplay () {
      this.popUp = true
      let offerId = this.gettersSelectedOffer
      if (offerId && offerId.id) {
        this.actionGetGoalsAndDisplay({offerId: offerId.id})
      } else {
        this.actionGetGoalsAndDisplay()
      }
    },
    closePopUp (value) {
      if (typeof value === 'object' && value.hasOwnProperty('goHome')) {
        this.popUp = false
        this.$router.push(value.path)
      }
      this.popUp = value
    },
    balanceTableHeight (reference, checkElWidth, ...moveAbleEls) {
      // console.log(reference, checkElWidth)
      if (this.hasScrollBars(reference, checkElWidth)) {
        moveAbleEls.forEach(el => {
          // console.log(el)
          el.style.top = '-22px'
        })
      }
    },
    hasScrollBars (el, width) {
      if (this.headers !== null) {
        return el.scrollWidth > width
      }
    },
    rejectOffer () {
      this.popUpType = 'rejectOffer'
      this.popUp = true
      this.mainContainerStyle = mainContainerStyle.mainStyle.rejectOffer
    },
    approveWithChanges () {
      this.popUpType = 'approveWithChanges'
      this.popUp = true
      this.mainContainerStyle = mainContainerStyle.mainStyle.approveWithChanges
    },
    screenAdjustment () {
      this.scrollableWidth = this.getScrollableWidth()
      this.marginLeft = this.getMarginLeft()
      this.modifyTableHeightByData('#offersHeaderContainer')
      this.modifyTableHeightByData('#offersSummaryContainer')
      this.modifyTableHeightByData('#offersDetailsScrollableX .inline-block.margin-fix')
      // console.log(this.scrollableWidth)
      /*  let offersHeaderContainer = document.getElementById('offersHeaderContainer')
      let offersSummaryContainer = document.getElementById('offersSummaryContainer')
      let scrollableX = document.getElementById('offersDetailsScrollableX')
      this.balanceTableHeight(scrollableX, this.scrollableWidth, offersHeaderContainer, offersSummaryContainer) */
    },
    openChartsVue () {
      if (this.buttonEnabled) {
        this.$router.push({ name: this.simulationRouteName, params: { buttonEnabled: this.buttonEnabled } })
      } else {
        this.$router.push({ name: this.waterfallRouteName, params: { buttonEnabled: this.buttonEnabled } })
      }
    },
    childEvent (data) {
      if (this.gettersSelectedOffer.id && this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
        if (this.pastOrPendingFlag === 'PAST') {
          this.offerTypeFlag = false
          this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true })
        } else {
          this.offerTypeFlag = true
          this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id })
        }
      }
    },
    validateInputField (value) {
      let regex = new RegExp(/^([+-])?\d{1,2}(\.\d{1,2})?$/)
      if (!regex.test(value)) {
        return true
      } else {
        return false
      }
    },
    topScrollContainer () {
      let scrollWrapper = document.getElementById('scrollWrapper')
      let actualWrapper = document.getElementById('offersDetailsScrollableX')
      actualWrapper.scrollLeft = scrollWrapper.scrollLeft
    },
    bottomScrollContainer () {
      let actualWrapper = document.getElementById('scrollWrapper')
      let scrollWrapper = document.getElementById('offersDetailsScrollableX')
      actualWrapper.scrollLeft = scrollWrapper.scrollLeft
    },
    modifyTableHeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.detailedData,
        this.scrollableChildrenWidth,
        '1.2rem',
        '1rem'
      )
      if (this.detailedData && this.detailedData.length) tableHeightAdjustment.modifyTableRowHeight(el)
    }
  },
  created () {
    if (this.$route.name === 'selectPastOffers') this.pastOrPendingFlag = 'PAST'
    else this.pastOrPendingFlag = 'PENDING'

    if (this.gettersSelectedOffer && this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
      if (this.pastOrPendingFlag === 'PAST') {
        this.offerTypeFlag = false
        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, actual_calc: true })
      } else {
        this.offerTypeFlag = true
        this.actionRequestOfferDetails({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id })
      }
    } else {
      this.$router.push(this.landingScreen)
    }
  },
  mounted () {
    this.screenAdjustment()
  },
  updated () {
    this.$nextTick(function () {
      this.screenAdjustment()
    })
  },
  components: {
    VerticalHeaderTable,
    DataTable,
    SideBar,
    PopUp,
    stickyNotifications
  }
}
</script>

<style lang="css" scoped>
  .height-10 {
    height: 10rem;
  }
  .height-12 {
    height: 12rem;
  }
  .padding-top-8 {
    padding-top: 8rem;
  }
  .padding-top-10 {
    padding-top: 10rem;
  }
  position-relative {
    position: relative;
  }
  button {
    font-size: 1rem;
    padding: 0.6rem 1.5rem;
    float: right;
    margin-left: 0.5rem;
  }
  .scrollWrapper {
  	height: 20px;
    overflow-x: scroll;
    overflow-y: hidden;
  }
  .simulateScrollDiv {
  	height: 20px;
  }
  .align-right {
    text-align: right;
  }
  .margin-fix {
    margin-left: -.5rem;
  }

  .scrollable-x {
    overflow-x: scroll;
  }

  .vertical-top {
    vertical-align: top;
  }
  .sideBar {
    background-color: #fff;
    padding: 0.5rem 1rem;
    box-shadow: 0 0 0.5rem #777;
    position: fixed;
    top: 0.4rem;
    left: 0.4rem;
    z-index: 10;
    opacity: 0;
    cursor: pointer;
    font-size: 1.5rem;
    transition: 2s;
  }
  .fade-in {
    opacity: 1;
  }
  .hide {
    display: none;
  }
  .margin-left {
    margin-left: 2rem;
  }
  .preview {
    text-align: center;
    background: #eee;
    padding: 0.5rem 0;
    margin: 0.5rem 0;
    border-radius: 0.2rem;
    border: 0.1rem solid #ccc;
    font-size: 1.5rem;
}

  #offersComponentInnerDiv > * {
    position: relative;
  }
  #offersHeaderContainer, #offersSummaryContainer {
    vertical-align: top;
  }

  .table-container > * {
    vertical-align: top;
  }
  .notification {
    color: #777;
  }
  .tooltip {
    position: relative;
  }
  .tooltip .tooltiptext {
    visibility: hidden;
    background-color: #333333;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    padding: 2px;
    position: absolute;
    z-index: 1;
    cursor: help;
    font-size: 1.2rem;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// OffersComponent.vue?17c96f31